import { PAGES } from '../../config';

/**
 * Fires bespoke events for given pages
 * @param {string} pageName - name of the current page
 * @param {object} data - pertinent tracking data
 * @param {Array} providers - Array of JG analytics providers (eg. GA, Kissmetrics,...)
 */
export const pageView = (pageName, data, providers) => {
	switch (pageName) {

	}
};




// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/lib/analytics/analytics.js